import { Skeleton } from "primereact/skeleton";
import { Button } from "primereact/button";
import { Image } from "primereact/image";

const RelatedProductsPanel = ({
    title = "Productos relacionados",
    relatedLoading = false,
    relatedItems = [],
    relatedError = "",
    currencyFormatter,
    onAddToCart = () => {},
}) => {
    const formatPrice = (value) => {
        const numeric = Number(value || 0);
        return currencyFormatter?.format ? currencyFormatter.format(numeric) : numeric;
    };

    return (
        <section className="cart-related">
            <h2>{title}</h2>

            {relatedError ? <div className="cart-related-status">{relatedError}</div> : null}
            {relatedLoading ? (
                <div className="cart-related-grid">
                    {[...Array(4)].map((_, i) => (
                        <article key={i} className="cart-related-card">
                            <Skeleton width="100%" height="10rem" />
                            <Skeleton width="80%" height="1rem" className="mt-2" />
                            <Skeleton width="40%" height="1rem" className="mt-1" />
                            <Skeleton width="100%" height="2.5rem" className="mt-2" />
                        </article>
                    ))}
                </div>
            ) : !relatedItems.length ? (
                <div className="cart-related-status">No encontramos productos relacionados.</div>
            ) : (
                <div className="cart-related-grid" style={{gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", overflow: "hidden"}}>
                    {relatedItems.slice(0, 4).map((item) => (
                        <article key={item.code} className="cart-related-card">
                            <Image src={item.image} alt={item.name}/>
                            <h3>{item.name}</h3>
                            <strong>{item.price ? formatPrice(item.price) : "Precio a consultar"}</strong>
                            <Button type="button" onClick={() => onAddToCart(item)} label="Agregar al carro" className="p-button-sm p-button-primary mt-2" />
                        </article>
                    ))}
                </div>
            )}
        </section>
    );
};

export default RelatedProductsPanel;
